import React, { useEffect, useReducer, useState, Suspense } from "react";
import { Typography, Grid, Box, Stack, Card, CardContent } from "@mui/material";

import { useNavigate } from "react-router-dom";
import HomeWorkIcon from "@mui/icons-material/HomeWorkOutlined";
import DirectionsCarIcon from "@mui/icons-material/DirectionsCarFilledOutlined";
import AccountBalanceIcon from "@mui/icons-material/AccountBalanceOutlined";
import CreditCardIcon from "@mui/icons-material/CreditCardOutlined";
import CandlestickIcon from "@mui/icons-material/CandlestickChartOutlined";
import BitcoinIcon from "@mui/icons-material/CurrencyBitcoinOutlined";
import DefaultLayout from "../Layout/DefaultLayout";
import { NewAssetCard } from "../Shared/Cards/NewAssetCard";
import { t } from "i18next";
import CorporateFareIcon from "@mui/icons-material/CorporateFareOutlined";
import { useTranslation } from "react-i18next";
import ReactHtmlParser from "html-react-parser";

const AddAssetIndex = ({ globalEvent, setGlobalEvent, title }) => {
  const navigate = useNavigate();
  const [checked, setChecked] = useState(false);
  const [verified, setVerified] = useState(false);
  const [user, setUser] = useState();

  const { t, i18n } = useTranslation();
  const [language, setLanguage] = useState(i18n.language);

  const mql = window.matchMedia("(max-width: 600px)");
  let mobileView = mql.matches;

  useEffect(() => {
    if (process.env.REACT_APP_LOG_MESSAGELOG == "on") {
      //console.log("------ Global Event ------ Landing");
      //console.log(globalEvent);
      //console.log("------------");
    }

    if (globalEvent?.type == "responseGetUser") {
      setUser(globalEvent?.data.user);
      //console.log(globalEvent?.data.user);

      if (!!globalEvent?.data.user.emailVerified) {
        setVerified(true);
      }
      if (!!globalEvent?.data.user.email_verified_at) {
        setVerified(true);
      }

      setChecked(true);
    }

    if (globalEvent?.type == "responseGetUserError") {
      localStorage.removeItem("token");
      navigate("/", { replace: true });
    }
  }, [globalEvent]);

  return (
    <>
      <DefaultLayout globalEvent={globalEvent} setGlobalEvent={setGlobalEvent}>
        <Box
          className="my-container"
          sx={{
            minHeight: "100vh",
            mt: { xs: 0, sm: 8 },
            mb: 10,
          }}
        >
          <Box>
            <Stack
              direction={"row"}
              spacing={2}
              alignItems={"center"}
              justifyContent={{ xs: "center", md: "left" }}
              sx={{ mb: 6 }}
            >
              {/*<BackButton linkTo="/dashboard" />*/}
              <Typography variant="h6">
                {ReactHtmlParser(t("asset.addNewAsset"))}
              </Typography>
            </Stack>
          </Box>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              width: "100%",
            }}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  px: { lg: 6, xl: 16 },
                }}
              >
                <Grid
                  container
                  spacing={{ xs: 1, sm: 2, md: 3 }}
                  sx={{
                    margin: "auto",
                    maxWidth: { md: "828px", sm: "560px", xs: "370px" },
                  }}
                >
                  <Grid
                    item
                    xs={6}
                    sm={4}
                    md={12 / 5}
                    sx={{ display: "flex", justifyContent: "center" }}
                  >
                    <NewAssetCard
                      globalEvent={globalEvent}
                      setGlobalEvent={setGlobalEvent}
                      subtype="realEstate"
                      link="/add-new-asset/real-estate"
                      icon={
                        <HomeWorkIcon
                          sx={{
                            width: "48px",
                            height: "48px",
                            color: "primary.main",
                            opacity: 0.6,
                          }}
                        />
                      }
                      datas={{ value: "0", currency: "HUF", details: {} }}
                      title={t("asset-type.real-estate")}
                    />
                  </Grid>
                  <Grid
                    item
                    xs={6}
                    sm={4}
                    md={12 / 5}
                    sx={{ display: "flex", justifyContent: "center" }}
                  >
                    <NewAssetCard
                      globalEvent={globalEvent}
                      setGlobalEvent={setGlobalEvent}
                      link="/add-new-asset/bank-account"
                      subtype="bankAccount"
                      icon={
                        <CreditCardIcon
                          sx={{
                            width: "48px",
                            height: "48px",
                            color: "primary.main",
                            opacity: 0.6,
                          }}
                        />
                      }
                      datas={{
                        value: "0",
                        currency: "HUF",
                        details: {},
                      }}
                      title={t("asset-type.bank-account")}
                    />
                  </Grid>
                  <Grid
                    item
                    xs={6}
                    sm={4}
                    md={12 / 5}
                    sx={{ display: "flex", justifyContent: "center" }}
                  >
                    <NewAssetCard
                      globalEvent={globalEvent}
                      setGlobalEvent={setGlobalEvent}
                      link="/add-new-asset/vehicle"
                      subtype="vehicle"
                      icon={
                        <DirectionsCarIcon
                          sx={{
                            width: "48px",
                            height: "48px",
                            color: "primary.main",
                            opacity: 0.6,
                          }}
                        />
                      }
                      datas={{ value: 0, currency: "HUF", details: {} }}
                      title={t("asset-type.vehicle")}
                    />
                  </Grid>
                  <Grid
                    item
                    xs={6}
                    sm={4}
                    md={12 / 5}
                    sx={{ display: "flex", justifyContent: "center" }}
                  >
                    <NewAssetCard
                      globalEvent={globalEvent}
                      setGlobalEvent={setGlobalEvent}
                      link="/add-new-asset/insurance"
                      subtype="insurance"
                      icon={
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            width: "48px",
                            height: "48px",
                            color: "primary.main",
                            opacity: 0.6,
                          }}
                        >
                          <svg
                            width="38"
                            height="36"
                            viewBox="0 0 38 36"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M18.9995 35.0191C18.5405 35.0191 18.0937 34.9332 17.6591 34.7614C17.2245 34.5896 16.8418 34.3319 16.5111 33.9883L3.49571 20.923C2.32905 19.7563 1.45468 18.4326 0.872612 16.9518C0.290545 15.4711 -0.000488281 13.9397 -0.000488281 12.3576C-0.000488281 9.20638 1.00721 6.5128 3.02261 4.2769C5.03798 2.04103 7.53283 0.923096 10.5072 0.923096C11.9918 0.923096 13.4039 1.22373 14.7437 1.82499C16.0834 2.42629 17.2776 3.26796 18.3263 4.34999L18.9995 5.06159L19.6341 4.38845C20.6751 3.28078 21.8687 2.42629 23.2149 1.82499C24.561 1.22373 25.97 0.923096 27.4418 0.923096C30.4161 0.923096 32.9193 2.04103 34.9513 4.2769C36.9834 6.5128 37.9994 9.18971 37.9994 12.3076C37.9994 13.9025 37.7033 15.4403 37.1109 16.9211C36.5186 18.4019 35.6494 19.7256 34.5032 20.8922L21.4379 33.9883C21.0943 34.3319 20.7167 34.5896 20.3052 34.7614C19.8937 34.9332 19.4584 35.0191 18.9995 35.0191ZM20.9995 10.5C21.2559 10.5 21.4956 10.5609 21.7187 10.6826C21.9417 10.8044 22.1174 10.9666 22.2456 11.1692L25.7802 16.5H34.0033C34.352 15.8308 34.6135 15.1436 34.7879 14.4384C34.9623 13.7333 35.043 13.023 35.0302 12.3076C34.9764 10.0076 34.2289 8.04546 32.7879 6.42109C31.3469 4.79673 29.5649 3.98455 27.4418 3.98455C26.3828 3.98455 25.3591 4.19416 24.3706 4.61339C23.3821 5.03263 22.5251 5.64481 21.7995 6.44994L20.2187 8.14995C20.0648 8.33715 19.8802 8.47625 19.6648 8.56725C19.4494 8.65828 19.2277 8.7038 18.9995 8.7038C18.7713 8.7038 18.5463 8.65508 18.3245 8.55764C18.1027 8.46021 17.9046 8.32431 17.7303 8.14995L16.1495 6.44994C15.4238 5.64481 14.5719 5.02238 13.5937 4.58264C12.6155 4.14288 11.5866 3.923 10.5072 3.923C8.38406 3.923 6.60201 4.74543 5.16101 6.3903C3.71998 8.0352 2.99946 10.0076 2.99946 12.3076C2.99946 13.0358 3.08151 13.7493 3.24561 14.448C3.40971 15.1468 3.65973 15.8308 3.99566 16.5H12.9995C13.2559 16.5 13.4924 16.5609 13.7091 16.6826C13.9257 16.8044 14.0982 16.9666 14.2264 17.1692L16.5533 20.6346L19.5803 11.5538C19.688 11.2436 19.8687 10.9904 20.1226 10.7942C20.3764 10.5981 20.6687 10.5 20.9995 10.5ZM21.4456 15.3652L18.4187 24.4461C18.311 24.7563 18.1219 25.0095 17.8514 25.2057C17.5809 25.4018 17.2802 25.4999 16.9495 25.4999C16.6931 25.4999 16.4565 25.439 16.2399 25.3172C16.0232 25.1954 15.8508 25.0333 15.7226 24.8307L12.1687 19.4999H6.31866L18.6495 31.8499C18.7161 31.9166 18.7745 31.9583 18.8245 31.9749C18.8745 31.9916 18.9328 31.9999 18.9995 31.9999C19.0661 31.9999 19.1245 31.9916 19.1745 31.9749C19.2245 31.9583 19.2828 31.9166 19.3495 31.8499L31.6495 19.4999H24.9995C24.7431 19.4999 24.5033 19.4358 24.2803 19.3076C24.0572 19.1794 23.8713 19.014 23.7226 18.8114L21.4456 15.3652Z"
                              fill="#2B3674"
                            />
                          </svg>
                        </Box>
                      }
                      datas={{ value: 0, currency: "HUF", details: {} }}
                      title={t("asset-type.insurance")}
                    />
                  </Grid>
                  <Grid
                    item
                    xs={6}
                    sm={4}
                    md={12 / 5}
                    sx={{ display: "flex", justifyContent: "center" }}
                  >
                    <NewAssetCard
                      globalEvent={globalEvent}
                      setGlobalEvent={setGlobalEvent}
                      link="/add-new-asset/security"
                      subtype="security"
                      icon={
                        <CandlestickIcon
                          sx={{
                            width: "48px",
                            height: "48px",
                            color: "primary.main",
                            opacity: 0.6,
                          }}
                        />
                      }
                      datas={{ value: 0, currency: "HUF", details: {} }}
                      title={t("asset-type.security")}
                    />
                  </Grid>
                  <Grid
                    item
                    xs={6}
                    sm={4}
                    md={12 / 5}
                    sx={{ display: "flex", justifyContent: "center" }}
                  >
                    <NewAssetCard
                      globalEvent={globalEvent}
                      setGlobalEvent={setGlobalEvent}
                      link="/add-new-asset/credit"
                      subtype="credit"
                      icon={
                        <Box
                          sx={{
                            textAlign: "center",
                            width: "48px",
                            height: "48px",
                            color: "primary.main",
                            opacity: 0.6,
                          }}
                        >
                          <svg
                            width="40"
                            height="41"
                            viewBox="0 0 40 41"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M24.7465 37.204C24.8106 37.2296 24.8683 37.2424 24.9196 37.2424C24.9709 37.2424 25.0285 37.2296 25.0926 37.204L36.8581 33.5616C36.7555 33.1078 36.5439 32.7597 36.2233 32.5174C35.9027 32.2751 35.5399 32.1539 35.135 32.1539H25.3403C24.4675 32.1539 23.726 32.1206 23.1157 32.0539C22.5055 31.9872 21.8786 31.8411 21.235 31.6155L18.0965 30.5885C17.6931 30.4603 17.4031 30.2039 17.2266 29.8193C17.0501 29.4347 17.026 29.0431 17.1542 28.6444C17.2824 28.2456 17.5305 27.9533 17.8984 27.7675C18.2664 27.5816 18.6529 27.5527 19.058 27.6809L21.658 28.5925C22.2632 28.7848 22.9401 28.9213 23.6888 29.0021C24.4375 29.0828 25.408 29.1335 26.6001 29.154H27.135C27.135 28.6591 27.0235 28.2322 26.8004 27.8732C26.5773 27.5142 26.2837 27.2719 25.9196 27.1463L14.3157 22.8848C14.2773 22.8719 14.242 22.8623 14.2099 22.8559C14.1779 22.8495 14.1427 22.8463 14.1042 22.8463H10.4041V33.1539L24.7465 37.204ZM23.9657 40.1423L10.4041 36.2539C10.1759 37.0821 9.71185 37.7468 9.01185 38.2481C8.31185 38.7494 7.57083 39 6.7888 39H4.01965C3.02541 39 2.1743 38.646 1.4663 37.938C0.758297 37.23 0.404297 36.3788 0.404297 35.3846V23.4617C0.404297 22.4675 0.758297 21.6164 1.4663 20.9084C2.1743 20.2004 3.02541 19.8464 4.01965 19.8464H14.082C14.2917 19.8464 14.5042 19.8694 14.7195 19.9156C14.9349 19.9617 15.1349 20.0156 15.3195 20.0771L26.9734 24.3694C27.8811 24.7053 28.6349 25.2995 29.2349 26.1521C29.8349 27.0046 30.1349 28.0053 30.1349 29.154H35.135C36.5709 29.154 37.7407 29.6175 38.6446 30.5444C39.5484 31.4713 40.0003 32.6744 40.0003 34.1539C40.0003 34.7206 39.8503 35.177 39.5503 35.5231C39.2503 35.8693 38.7965 36.1436 38.1888 36.3462L26.0542 40.1116C25.726 40.2192 25.3811 40.2763 25.0196 40.2827C24.6581 40.2891 24.3068 40.2423 23.9657 40.1423ZM3.40425 35.3846C3.40425 35.5641 3.46193 35.7116 3.5773 35.827C3.6927 35.9424 3.84015 36.0001 4.01965 36.0001H6.7888C6.9683 36.0001 7.11575 35.952 7.23115 35.8558C7.34655 35.7596 7.40425 35.6026 7.40425 35.3846V22.8463H4.01965C3.84015 22.8463 3.6927 22.904 3.5773 23.0194C3.46193 23.1348 3.40425 23.2822 3.40425 23.4617V35.3846ZM24.4967 0.977051C24.8606 0.977051 25.2182 1.03219 25.5695 1.14245C25.9208 1.25269 26.2606 1.4219 26.5888 1.6501L36.4734 8.70395C36.9554 9.03215 37.3304 9.45715 37.5984 9.97895C37.8663 10.5008 38.0003 11.0565 38.0003 11.6463V23.2694C38.0003 23.6944 37.8565 24.0506 37.5689 24.3381C37.2812 24.6256 36.9248 24.7694 36.4997 24.7694C36.0745 24.7694 35.7183 24.6256 35.4311 24.3381C35.1439 24.0506 35.0004 23.6944 35.0004 23.2694V11.5963C35.0004 11.4937 34.9779 11.3975 34.9331 11.3078C34.8882 11.218 34.8208 11.1411 34.7311 11.077L24.8465 4.17315C24.7439 4.09622 24.6285 4.05775 24.5003 4.05775C24.3721 4.05775 24.2567 4.09622 24.1541 4.17315L14.2695 11.077C14.1798 11.1411 14.1125 11.218 14.0676 11.3078C14.0227 11.3975 14.0003 11.4937 14.0003 11.5963V13.9618C14.0003 14.3867 13.8565 14.743 13.5688 15.0305C13.2812 15.318 12.9248 15.4617 12.4996 15.4617C12.0744 15.4617 11.7183 15.318 11.4311 15.0305C11.1439 14.743 11.0003 14.3867 11.0003 13.9618V11.6463C11.0003 11.0565 11.1343 10.5008 11.4022 9.97895C11.6702 9.45715 12.0452 9.03215 12.5272 8.70395L22.4118 1.6501C22.74 1.4219 23.0786 1.25269 23.4274 1.14245C23.7762 1.03219 24.1327 0.977051 24.4967 0.977051ZM22.5003 12.4424C22.7413 12.4424 22.9522 12.352 23.133 12.1713C23.3138 11.9905 23.4041 11.7796 23.4041 11.5386C23.4041 11.2975 23.3138 11.0866 23.133 10.9059C22.9522 10.7251 22.7413 10.6347 22.5003 10.6347C22.2593 10.6347 22.0484 10.7251 21.8676 10.9059C21.6868 11.0866 21.5964 11.2975 21.5964 11.5386C21.5964 11.7796 21.6868 11.9905 21.8676 12.1713C22.0484 12.352 22.2593 12.4424 22.5003 12.4424ZM26.5003 12.4424C26.7413 12.4424 26.9522 12.352 27.133 12.1713C27.3138 11.9905 27.4042 11.7796 27.4042 11.5386C27.4042 11.2975 27.3138 11.0866 27.133 10.9059C26.9522 10.7251 26.7413 10.6347 26.5003 10.6347C26.2593 10.6347 26.0484 10.7251 25.8676 10.9059C25.6868 11.0866 25.5964 11.2975 25.5964 11.5386C25.5964 11.7796 25.6868 11.9905 25.8676 12.1713C26.0484 12.352 26.2593 12.4424 26.5003 12.4424ZM22.5003 16.4424C22.7413 16.4424 22.9522 16.352 23.133 16.1713C23.3138 15.9905 23.4041 15.7796 23.4041 15.5386C23.4041 15.2975 23.3138 15.0866 23.133 14.9059C22.9522 14.7251 22.7413 14.6347 22.5003 14.6347C22.2593 14.6347 22.0484 14.7251 21.8676 14.9059C21.6868 15.0866 21.5964 15.2975 21.5964 15.5386C21.5964 15.7796 21.6868 15.9905 21.8676 16.1713C22.0484 16.352 22.2593 16.4424 22.5003 16.4424ZM26.5003 16.4424C26.7413 16.4424 26.9522 16.352 27.133 16.1713C27.3138 15.9905 27.4042 15.7796 27.4042 15.5386C27.4042 15.2975 27.3138 15.0866 27.133 14.9059C26.9522 14.7251 26.7413 14.6347 26.5003 14.6347C26.2593 14.6347 26.0484 14.7251 25.8676 14.9059C25.6868 15.0866 25.5964 15.2975 25.5964 15.5386C25.5964 15.7796 25.6868 15.9905 25.8676 16.1713C26.0484 16.352 26.2593 16.4424 26.5003 16.4424Z"
                              fill="#2B3674"
                            />
                          </svg>
                        </Box>
                      }
                      datas={{ value: 0, currency: "HUF", details: {} }}
                      title={t("asset-type.credit")}
                    />
                  </Grid>
                  <Grid
                    item
                    xs={6}
                    sm={4}
                    md={12 / 5}
                    sx={{ display: "flex", justifyContent: "center" }}
                  >
                    <NewAssetCard
                      globalEvent={globalEvent}
                      setGlobalEvent={setGlobalEvent}
                      link="/add-new-asset/share"
                      subtype="share"
                      icon={
                        <Box
                          sx={{
                            textAlign: "center",
                            width: "48px",
                            height: "48px",
                            color: "primary.main",
                            opacity: 0.6,
                          }}
                        >
                          <svg
                            width="38"
                            height="35"
                            viewBox="0 0 38 35"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M3.6154 35C2.60513 35 1.75 34.65 1.05 33.95C0.35 33.25 0 32.3949 0 31.3846V10.6155C0 9.60528 0.35 8.75014 1.05 8.05014C1.75 7.35014 2.60513 7.00014 3.6154 7.00014H12V3.61559C12 2.60536 12.35 1.75024 13.05 1.05024C13.75 0.350244 14.6051 0.000244141 15.6154 0.000244141H22.3845C23.3948 0.000244141 24.2499 0.350244 24.9499 1.05024C25.6499 1.75024 25.9999 2.60536 25.9999 3.61559V7.00014H34.3845C35.3948 7.00014 36.2499 7.35014 36.9499 8.05014C37.6499 8.75014 37.9999 9.60528 37.9999 10.6155V31.3846C37.9999 32.3949 37.6499 33.25 36.9499 33.95C36.2499 34.65 35.3948 35 34.3845 35H3.6154ZM15 7.00014H23V3.61559C23 3.46173 22.9359 3.3207 22.8077 3.1925C22.6794 3.06426 22.5384 3.00014 22.3845 3.00014H15.6154C15.4615 3.00014 15.3205 3.06426 15.1923 3.1925C15.0641 3.3207 15 3.46173 15 3.61559V7.00014ZM35 23.5H23.9999V25.1923C23.9999 25.7077 23.8275 26.1378 23.4826 26.4827C23.1377 26.8276 22.7076 27 22.1922 27H15.8077C15.2923 27 14.8622 26.8276 14.5174 26.4827C14.1725 26.1378 14 25.7077 14 25.1923V23.5H2.99995V31.3846C2.99995 31.5385 3.06405 31.6796 3.19225 31.8078C3.32048 31.936 3.46153 32.0001 3.6154 32.0001H34.3845C34.5384 32.0001 34.6794 31.936 34.8077 31.8078C34.9359 31.6796 35 31.5385 35 31.3846V23.5ZM17 24.0001H21V20.0001H17V24.0001ZM2.99995 20.5001H14V18.8078C14 18.2925 14.1725 17.8624 14.5174 17.5175C14.8622 17.1726 15.2923 17.0001 15.8077 17.0001H22.1922C22.7076 17.0001 23.1377 17.1726 23.4826 17.5175C23.8275 17.8624 23.9999 18.2925 23.9999 18.8078V20.5001H35V10.6155C35 10.4617 34.9359 10.3206 34.8077 10.1924C34.6794 10.0642 34.5384 10.0001 34.3845 10.0001H3.6154C3.46153 10.0001 3.32048 10.0642 3.19225 10.1924C3.06405 10.3206 2.99995 10.4617 2.99995 10.6155V20.5001Z"
                              fill="#2B3674"
                            />
                          </svg>
                        </Box>
                      }
                      datas={{ value: 0, currency: "HUF", details: {} }}
                      title={t("asset-type.share")}
                    />
                  </Grid>

                  <Grid
                    item
                    xs={6}
                    sm={4}
                    md={12 / 5}
                    sx={{ display: "flex", justifyContent: "center" }}
                  >
                    <NewAssetCard
                      globalEvent={globalEvent}
                      setGlobalEvent={setGlobalEvent}
                      link="/add-new-asset/claim"
                      subtype="claim"
                      icon={
                        <AccountBalanceIcon
                          sx={{
                            width: "48px",
                            height: "48px",
                            color: "primary.main",
                            opacity: 0.6,
                          }}
                        />
                      }
                      datas={{ value: 0, currency: "HUF", details: {} }}
                      title={t("asset-type.savings")}
                    />
                  </Grid>
                  <Grid
                    item
                    xs={6}
                    sm={4}
                    md={12 / 5}
                    sx={{ display: "flex", justifyContent: "center" }}
                  >
                    <NewAssetCard
                      globalEvent={globalEvent}
                      setGlobalEvent={setGlobalEvent}
                      link="/add-new-asset/crypto"
                      subtype="crypto"
                      icon={
                        <BitcoinIcon
                          sx={{
                            width: "48px",
                            height: "48px",
                            color: "primary.main",
                            opacity: 0.6,
                          }}
                        />
                      }
                      datas={{ value: 0, currency: "HUF", details: {} }}
                      title={t("asset-type.crypto")}
                    />
                  </Grid>
                  <Grid
                    item
                    xs={6}
                    sm={4}
                    md={12 / 5}
                    sx={{ display: "flex", justifyContent: "center" }}
                  >
                    <NewAssetCard
                      globalEvent={globalEvent}
                      setGlobalEvent={setGlobalEvent}
                      link="/add-new-asset/other"
                      subtype="other"
                      icon={
                        <Box
                          sx={{
                            textAlign: "center",
                            width: "48px",
                            height: "48px",
                            color: "primary.main",
                            opacity: 0.6,
                          }}
                        >
                          <svg
                            width="26"
                            height="38"
                            viewBox="0 0 26 38"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M10.9157 34.8077C10.6157 33.938 10.2323 33.1351 9.76567 32.3992C9.29901 31.6632 8.74901 30.9774 8.11567 30.3419C7.48234 29.7063 6.79901 29.15 6.06567 28.6731C5.33234 28.1962 4.53234 27.8077 3.66567 27.5077C3.73234 28.4744 3.96567 29.3744 4.36567 30.2077C4.76567 31.0411 5.29901 31.7911 5.96567 32.4577C6.63234 33.1244 7.38234 33.6628 8.21567 34.0731C9.04901 34.4833 9.94901 34.7282 10.9157 34.8077ZM15.0656 34.8077C16.0322 34.7205 16.934 34.4769 17.7709 34.0769C18.6078 33.6769 19.361 33.1436 20.0305 32.4769C20.7 31.8103 21.2348 31.0571 21.6348 30.2173C22.0348 29.3776 22.2784 28.4744 22.3656 27.5077C21.5019 27.8077 20.6965 28.1911 19.9491 28.6577C19.2018 29.1244 18.5125 29.6744 17.8814 30.3077C17.2503 30.9411 16.699 31.6327 16.2275 32.3827C15.756 33.1327 15.3687 33.9411 15.0656 34.8077ZM13.0002 17.577C15.1618 17.577 17.0034 16.8161 18.5252 15.2943C20.047 13.7725 20.8079 11.9309 20.8079 9.76932V6.79232L17.3079 9.74232L13.0002 4.29232L8.69252 9.74232L5.19252 6.79232V9.76932C5.19252 11.9309 5.95342 13.7725 7.47522 15.2943C8.99702 16.8161 10.8387 17.577 13.0002 17.577ZM11.6157 37.8076C8.56014 37.8076 5.96292 36.7382 3.82402 34.5993C1.68516 32.4605 0.615723 29.8633 0.615723 26.8077V23.9232C2.85419 24.0693 4.93367 24.6905 6.85417 25.7867C8.77467 26.8828 10.3234 28.2873 11.5003 30.0001V20.4846C8.85157 20.1334 6.63812 18.9488 4.85992 16.9308C3.08172 14.9129 2.19262 12.5257 2.19262 9.76932V4.16172C2.19262 3.37199 2.54391 2.82134 3.24647 2.50977C3.94901 2.19824 4.59516 2.30017 5.18492 2.81557L8.30792 5.51552L11.5849 1.37322C11.951 0.932188 12.4239 0.71167 13.0037 0.71167C13.5834 0.71167 14.054 0.932188 14.4156 1.37322L17.6925 5.51552L20.8155 2.81557C21.4053 2.30017 22.0514 2.19824 22.754 2.50977C23.4565 2.82134 23.8078 3.37199 23.8078 4.16172V9.76932C23.8078 12.5257 22.9187 14.9129 21.1405 16.9308C19.3623 18.9488 17.1489 20.1334 14.5002 20.4846V29.9809C15.6771 28.2809 17.2226 26.8828 19.1367 25.7867C21.0508 24.6905 23.1206 24.0693 25.3463 23.9232V26.8077C25.3463 29.8633 24.2787 32.4605 22.1436 34.5993C20.0084 36.7382 17.4158 37.8076 14.3656 37.8076H11.6157Z"
                              fill="#2B3674"
                            />
                          </svg>
                        </Box>
                      }
                      datas={{ value: 0, currency: "HUF", details: {} }}
                      title={t("asset-type.other")}
                    />
                  </Grid>
                </Grid>
              </Box>
            </Box>
          </Box>
        </Box>
      </DefaultLayout>
    </>
  );
};

export default AddAssetIndex;
